import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import type { RirekishoExampleSentence } from '@/composables/format-edit/useRirekishoFormatData'
import esfOptions from '@/utils/format-edit/rirekishoEsfOptions.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoRecommendCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



const formatData = useRirekishoFormatData()
const sampleVisible = ref(false)

function onSelectSample(item: RirekishoExampleSentence) {
  formatData.requestStatement += item.description.replace(/<br>/gi, '\n') + '\n'
}

return { __sfc: true,formatData, sampleVisible, onSelectSample, NewRirekishoExampleSentenceDialog, esfOptions }
}

})